import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Band, PullQuote } from './Band';
import { candidateFacts } from '../../data/site';
export function Candidates() {
  return <Band id="candidates" eyebrow="For candidates" title="What candidates are told." description="A process people resent produces attrition among exactly the candidates you wanted. So the terms are stated up front, in plain language." aside={<PullQuote data-id="element-24" data-mp="3egczkywu45wj">
          Nothing about the session depends on the candidate not knowing how it
          works.
        </PullQuote>} data-id="element-23" data-mp="35gq8p71qeihq">
      <ul className="grid gap-px overflow-hidden rounded-2xl border border-mist bg-mist md:grid-cols-2 lg:grid-cols-3" data-id="element-25" data-mp="39i1sux1u6bij">
        {candidateFacts.map(fact => <li key={fact} className="flex items-start gap-3 bg-bone p-7" data-id="element-26" data-mp="3j7lci4xdi9eg">
            <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-27" data-mp="12i0s1cwiz52" />
            <span className="max-w-[36ch] text-lg leading-relaxed text-ink" data-id="element-28" data-mp="105kdsmskwu4">
              {fact}
            </span>
          </li>)}
      </ul>
    </Band>;
}